
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3kT7K", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $10b9f6e004586f20$export$2e2bcd8739ae039);

var $eKTQH = parcelRequire("eKTQH");

var $14RSn = parcelRequire("14RSn");

var $5WnGE = parcelRequire("5WnGE");


var $cblKs = parcelRequire("cblKs");

var $4cTDP = parcelRequire("4cTDP");
async function $10b9f6e004586f20$export$2e2bcd8739ae039(_, { tenantContext: tenantContext }) {
    if (tenantContext.appEditions.serviceDesk !== (0, $cblKs.STANDARD_EDITION) || !tenantContext.atlassianAccountId || !tenantContext.isSiteAdmin) return;
    const entitlementId = tenantContext.productEntitlementDetails?.[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61]?.entitlementId;
    if (!entitlementId) {
        (0, $eKTQH.default)({
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                teamName: 'Sequoia'
            },
            error: new (0, $14RSn.ValidationError)('Entitlement ID is not set. Cannot fetch GP end date.'),
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
    try {
        const gpEndDateDetails = await (0, $5WnGE.getGpEndDateDetails)(tenantContext.isSiteAdmin, entitlementId);
        const gracePeriodEndDate = (0, $5WnGE.calculateGpEndDateWithoutFormat)(gpEndDateDetails.maintenanceEndDate, gpEndDateDetails.billingPeriod);
        return {
            gpEndDateDetails: gpEndDateDetails,
            gracePeriodEndDate: gracePeriodEndDate
        };
    } catch (error) {
        (0, $eKTQH.default)({
            meta: {
                id: 'getGpEndDate',
                packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                teamName: 'Sequoia'
            },
            error: error instanceof Error ? error : new Error(String(error)),
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $4cTDP.fg)('jsm_gp_rethrow_err_resources')) throw error;
    }
}

});
parcelRegister("5WnGE", function(module, exports) {
$parcel$export(module.exports, "getGpEndDateDetails", () => $1efda87d62f67bd5$export$eabf75da11894c5c);
$parcel$export(module.exports, "calculateGpEndDate", () => $1efda87d62f67bd5$export$cb353b4a113623c);
$parcel$export(module.exports, "calculateGpEndDateWithoutFormat", () => $1efda87d62f67bd5$export$b7b68457e67df636);

var $dBLX0 = parcelRequire("dBLX0");
var $cT05m = parcelRequire("cT05m");

var $3ugTQ = parcelRequire("3ugTQ");

var $dO9h7 = parcelRequire("dO9h7");
const $1efda87d62f67bd5$var$JSM_CONTEXT_URL = '/rest/servicedesk/latest/jsmcontext';
const $1efda87d62f67bd5$var$getSubscriptionsUrl = (entitlementId)=>`/gateway/api/ccp/api/v2/entitlements/${entitlementId}/details`;
// The Packaging GP enforcement date is October 16, 2025.
const $1efda87d62f67bd5$var$PACKAGING_GP_ENFORCEMENT_DATE = new Date('2025-10-16');
const $1efda87d62f67bd5$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    const parsedDate = (0, $cT05m.default)(date, dateFormat, new Date());
    return (0, $dBLX0.default)(parsedDate);
};
const $1efda87d62f67bd5$var$getSubscriptionsDateDetails = async (entitlementId)=>{
    const data = await (0, $3ugTQ.performGetRequest)($1efda87d62f67bd5$var$getSubscriptionsUrl(entitlementId));
    return data.subscriptionv2.endTimestamp;
};
const $1efda87d62f67bd5$var$getJsmContextDateDetails = async ()=>{
    const data = await (0, $3ugTQ.performGetRequest)($1efda87d62f67bd5$var$JSM_CONTEXT_URL);
    if (data.maintenanceEndDate && !$1efda87d62f67bd5$var$dateHasExpectedFormat(data.maintenanceEndDate)) throw new Error(`Invalid maintenance end date, received: ${data.maintenanceEndDate}`);
    if (data.billingPeriod !== 'MONTHLY' && data.billingPeriod !== 'ANNUAL') throw new Error(`Invalid billing period, received: ${data.billingPeriod}`);
    return {
        // Users with termed subscriptions before Aug 2024 will have no maintenance end date in the JSM context.
        maintenanceEndDate: data.maintenanceEndDate ? new Date(data.maintenanceEndDate) : undefined,
        billingPeriod: data.billingPeriod
    };
};
const $1efda87d62f67bd5$export$eabf75da11894c5c = async (isAdmin, entitlementId)=>{
    if (!isAdmin) throw new Error('Insufficient permissions to access GP end date');
    // Try the primary method first
    const jsmContextDateDetails = await $1efda87d62f67bd5$var$getJsmContextDateDetails();
    if (jsmContextDateDetails.maintenanceEndDate) return {
        maintenanceEndDate: jsmContextDateDetails.maintenanceEndDate,
        billingPeriod: jsmContextDateDetails.billingPeriod
    };
    if (!entitlementId) throw new Error('Insufficient data to access GP end date');
    // If primary method fails, try the fallback. This is for users with termed subscriptions before Aug 2024.
    const endTimestamp = await $1efda87d62f67bd5$var$getSubscriptionsDateDetails(entitlementId);
    if (!endTimestamp || !Number.isInteger(endTimestamp)) throw new Error(`Invalid end timestamp from subscriptions, received: ${endTimestamp}`);
    return {
        // Convert from seconds to milliseconds. endTimestamp is a UNIX timestamp.
        maintenanceEndDate: new Date(endTimestamp * 1000),
        billingPeriod: jsmContextDateDetails.billingPeriod
    };
};
const $1efda87d62f67bd5$var$getMonthlyBillingGPEndDate = (date)=>{
    const currentBillingDate = date;
    while(currentBillingDate < $1efda87d62f67bd5$var$PACKAGING_GP_ENFORCEMENT_DATE)currentBillingDate.setMonth(currentBillingDate.getMonth() + 1);
    return currentBillingDate;
};
const $1efda87d62f67bd5$var$getAnnualBillingGPEndDate = (date)=>{
    const currentBillingDate = date;
    while(currentBillingDate < $1efda87d62f67bd5$var$PACKAGING_GP_ENFORCEMENT_DATE)currentBillingDate.setFullYear(currentBillingDate.getFullYear() + 1);
    return currentBillingDate;
};
const $1efda87d62f67bd5$export$cb353b4a113623c = (maintenanceEndDate, billingPeriod, locale)=>{
    const gpEndDate = $1efda87d62f67bd5$export$b7b68457e67df636(maintenanceEndDate, billingPeriod);
    return gpEndDate ? (0, $dO9h7.formatWithLocale)(gpEndDate, 'MMM dd, yyyy', locale) : undefined;
};
const $1efda87d62f67bd5$export$b7b68457e67df636 = (maintenanceEndDate, billingPeriod)=>{
    if (billingPeriod === 'MONTHLY') return $1efda87d62f67bd5$var$getMonthlyBillingGPEndDate(maintenanceEndDate);
    if (billingPeriod === 'ANNUAL') return $1efda87d62f67bd5$var$getAnnualBillingGPEndDate(maintenanceEndDate);
};

});

const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';



//# sourceMappingURL=async-resource-jsm-grace-period-announcements-gp-end-date.81ec4653.js.map
